import type { MaintenanceState } from '@flux/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client.js';
import { queryKeys } from '@/lib/query/keys.js';

function fetchMaintenanceState(): Promise<MaintenanceState> {
  return apiFetch<MaintenanceState>('/api/settings/maintenance');
}

/**
 * Bandeau maintenance global (`02` §0) : interrogé toutes les 30 s sur chaque
 * page, léger (`maintenanceStateSchema` seul, pas le tableau de bord entier).
 */
export function useMaintenanceState(): UseQueryResult<MaintenanceState> {
  return useQuery({
    queryKey: queryKeys.settings.maintenance(),
    queryFn: fetchMaintenanceState,
    refetchInterval: 30_000,
  });
}
